import { CIcon } from '~/icons/types'

export const ciBusinessEquipment: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.472 17.514v-.037l-.007-.018-2.568-6.851v-2.52a1.371 1.371 0 0 0-1.37-1.369h-2.549v-1.61h1.543a1.5 1.5 0 0 0 1.5-1.5V3a1.5 1.5 0 0 0-1.5-1.5h-4.086a1.5 1.5 0 0 0-1.5 1.5v.609a1.5 1.5 0 0 0 1.5 1.5h1.543v1.61h-2.543a1.37 1.37 0 0 0-1.37 1.369v.369H9.456V6.348a.5.5 0 0 0-.5-.5H6.348a.5.5 0 0 0-.5.5v2.109h-.189a1.373 1.373 0 0 0-1.291.918l-2.84 8.113c-.005.015 0 .032-.005.048a.5.5 0 0 0-.023.116v3.478a1.37 1.37 0 0 0 1.369 1.37h18.262a1.371 1.371 0 0 0 1.369-1.37v-3.478a.493.493 0 0 0-.028-.138Zm-9.537-13.9V3a.5.5 0 0 1 .5-.5h4.086a.5.5 0 0 1 .5.5v.609a.5.5 0 0 1-.5.5h-4.086a.5.5 0 0 1-.5-.5v.005Zm-.87 4.479a.37.37 0 0 1 .37-.369h6.087a.37.37 0 0 1 .37.369V10.2h-6.827V8.093ZM6.848 6.848h1.608V10.2H6.848V6.848ZM5.312 9.705a.369.369 0 0 1 .348-.248h.188v.751a.5.5 0 0 0 .065.987h3.479a.5.5 0 0 0 .064-.987v-.751h1.609V10.7a.5.5 0 0 0 .5.5h7.481l2.232 5.955H2.705l2.607-7.45ZM21.131 21.5H2.869a.37.37 0 0 1-.369-.37v-2.977h19v2.977a.37.37 0 0 1-.369.37Z'
    },
    {
      d:
        'M13.739 19.5h-3.478a.5.5 0 0 0 0 1h3.478a.5.5 0 0 0 0-1Zm-8.26-3.957h.869a.5.5 0 0 0 0-1h-.869a.5.5 0 1 0 0 1Zm2.608 0h.869a.5.5 0 0 0 0-1h-.869a.5.5 0 1 0 0 1Zm2.613 0h.87a.5.5 0 0 0 0-1h-.87a.5.5 0 1 0 0 1Zm-2.613-1.738h.869a.5.5 0 0 0 0-1h-.869a.5.5 0 0 0 0 1Zm2.613 0h.87a.5.5 0 0 0 0-1h-.87a.5.5 0 0 0 0 1Zm3.909 1.738h.87a.5.5 0 0 0 0-1h-.87a.5.5 0 1 0 0 1Zm0-1.738h.87a.5.5 0 0 0 0-1h-.87a.5.5 0 0 0 0 1Zm2.609 1.738h.869a.5.5 0 0 0 0-1h-.869a.5.5 0 1 0 0 1Zm0-1.738h.869a.5.5 0 0 0 0-1h-.869a.5.5 0 0 0 0 1Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'business-equipment',
  type: 'thin'
}
